import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import VoucherAdd from './VoucherAdd'
import { write, utils } from 'xlsx'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Button from '../../common/CustomComponents/Button'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class VoucherList extends React.Component {
  state = {
    data: [],
    search: {
      name: '',
      code: '',
      user: '',
    },
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
    isloading: false,
  }
  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    this.setState({
      isloading: true,
      data: [],
    })

    await axios
      .get(Constant.getAPI() + '/admin/list-vouchers', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          ...this.state.search,
          keyword: this.state.keyword,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
            isSearching: false,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.setState({
            isSearching: false,
          })
        }
      })
      .finally(() => {
        this.setState({
          isloading: false,
        })
      })
  }
  deleteVoucher = (id) => {
    Swal.fire({
      title: 'Are you sure to delete this Voucher?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        axios
          .delete(Constant.getAPI() + `/admin/delete-voucher/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              title: 'Voucher Deleted Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
            this.getData()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  handleStatusChange = async (id, is_active) => {
    var data = { id, is_active }
    let that = this
    await axios
      .put(Constant.getAPI() + '/admin/voucher-status-update', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  editVoucher = (id) => {
    const voucher = this.state.data.find((item) => item.id == id)
    if (voucher) {
      this.setState({
        editVoucherData: voucher,
        editVoucherId: id,
      })
    }
    window.scrollTo(0, 0)
  }

  clearEdit = () => {
    this.setState({
      editVoucherData: null,
      editVoucherId: null,
    })
  }

  reloadList = () => {
    this.setState(
      {
        search: {
          code: '',
          name: '',
          user: '',
        },
        editVoucherId: null,
        editVoucherData: null,
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getData()
      }
    )
  }

  search = () => {
    this.setState({
      isSearching: true,
    })

    this.getData()
  }

  searchDataChange = (event) => {
    this.setState({
      search: {
        ...this.state.search,
        [event.target.name]: event.target.value,
      },
    })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.getData()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getData()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const customToolbar = () => {
      return (
        <>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={this.state.search.name}
                  name="name"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Email/Phone"
                  value={this.state.search.user}
                  name="user"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Voucher Code"
                  value={this.state.search.code}
                  name="code"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <Button
                disabled={this.state.isSearching}
                onClick={this.search}
                startIcon={<i className="ti-search"></i>}
              >
                Search
              </Button>
              <Button onClick={this.reloadList}>Clear</Button>
            </div>
          </div>
        </>
      )
    }

    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          sort: true,
          display: false,
        },
      },
      {
        name: 'name',
        label: 'Name',
        options: {
          sort: true,
        },
      },
      {
        name: 'code',
        label: 'Code',
        options: {
          sort: true,
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          sort: true,
        },
      },
      {
        name: 'voucher_creator',
        label: 'Created By',
        options: {
          sort: false,
          customBodyRender: (obj) => {
            return (
              <>
                <span>Email: {obj?.email || '--'}</span>
                <br></br>
                <span>Phone: {obj?.phone || '--'}</span>
              </>
            )
          },
        },
      },
      {
        name: 'is_redeemed',
        label: 'Redeemed',
        options: {
          sort: false,
          customBodyRender: (value) => {
            return <span>{value == true ? 'Yes' : 'No'}</span>
          },
        },
      },
      {
        name: 'voucher_user',
        label: 'Redeemed By',
        options: {
          sort: false,
          customBodyRender: (obj) => {
            return (
              <>
                <span>Email: {obj?.email || '--'}</span>
                <br></br>
                <span>Phone: {obj?.phone || '--'}</span>
              </>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={isActive}
                // value={isActive}
                onChange={this.handleStatusChange.bind(this, id, !isActive)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                {/* <span
                  onClick={this.editVoucher.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>{' '}
                </span> */}
                <span
                  onClick={this.deleteVoucher.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filter: false,
      download: true,
      downloadOptions: {
        filename: 'VoucherList',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `VoucherList`
        const col = ['id', 'name', 'code', 'amount', 'is_active', 'is_redeemed']

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (col.includes(columns[idx].name)) {
              temp[columns[idx].name] = v
            }
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      search: false,
      viewColumns: false,
      print: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.getData()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.getData()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isloading ? <Loader open={this.state.isloading} /> : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <>
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Voucher {this.state.editVoucherId ? 'Edit' : 'Add'}</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Voucher List</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <VoucherAdd
                        language_id={this.state.language_id}
                        list={this.state.data}
                        editVoucherId={this.state.editVoucherId}
                        editVoucherData={this.state.editVoucherData}
                        clearEdit={this.clearEdit}
                        reloadList={this.reloadList}
                      ></VoucherAdd>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-block">
                        <div className="dt-responsive table-responsive">
                          <MUIDataTable
                            title={customToolbar()}
                            className="table-responsive"
                            data={this.state.data}
                            columns={columns}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default VoucherList
